import { render } from "./DescriptionTextBoxComponent.vue?vue&type=template&id=1ff7b32e"
import script from "./DescriptionTextBoxComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionTextBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__